import { supabase } from '../lib/supabase';

export const permitService = {
  async getAll() {
    const { data, error } = await supabase?.from('work_permits')?.select(`
        *,
        employees (
          employee_number,
          first_name,
          last_name,
          department,
          position,
          email
        )
      `)?.order('expiry_date', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      employeeId: row?.employee_id,
      employee: row?.employees ? {
        employeeNumber: row?.employees?.employee_number,
        firstName: row?.employees?.first_name,
        lastName: row?.employees?.last_name,
        department: row?.employees?.department,
        position: row?.employees?.position,
        email: row?.employees?.email
      } : null,
      permitNumber: row?.permit_number,
      issueDate: row?.issue_date,
      expiryDate: row?.expiry_date,
      permitStatus: row?.permit_status,
      roleAlignment: row?.role_alignment,
      localizationCommitment: row?.localization_commitment,
      notes: row?.notes,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    })) || [];
  },

  async getByEmployeeId(employeeId) {
    const { data, error } = await supabase?.from('work_permits')?.select('*')?.eq('employee_id', employeeId)?.order('issue_date', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      permitNumber: row?.permit_number,
      issueDate: row?.issue_date,
      expiryDate: row?.expiry_date,
      permitStatus: row?.permit_status,
      roleAlignment: row?.role_alignment,
      localizationCommitment: row?.localization_commitment,
      notes: row?.notes
    })) || [];
  },

  async create(permit) {
    const { data, error } = await supabase?.from('work_permits')?.insert({
        employee_id: permit?.employeeId,
        permit_number: permit?.permitNumber,
        issue_date: permit?.issueDate,
        expiry_date: permit?.expiryDate,
        permit_status: permit?.permitStatus || 'active',
        role_alignment: permit?.roleAlignment,
        localization_commitment: permit?.localizationCommitment,
        notes: permit?.notes
      })?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      employeeId: data?.employee_id,
      permitNumber: data?.permit_number,
      issueDate: data?.issue_date,
      expiryDate: data?.expiry_date,
      permitStatus: data?.permit_status,
      createdAt: data?.created_at
    };
  },

  async update(id, permit) {
    const { data, error } = await supabase?.from('work_permits')?.update({
        permit_status: permit?.permitStatus,
        expiry_date: permit?.expiryDate,
        role_alignment: permit?.roleAlignment,
        localization_commitment: permit?.localizationCommitment,
        notes: permit?.notes
      })?.eq('id', id)?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      permitStatus: data?.permit_status,
      expiryDate: data?.expiry_date,
      updatedAt: data?.updated_at
    };
  },

  async getExpiringPermits(daysThreshold = 90) {
    const today = new Date();
    const thresholdDate = new Date();
    thresholdDate?.setDate(today?.getDate() + daysThreshold);

    const { data, error } = await supabase?.from('work_permits')?.select(`
        *,
        employees (
          employee_number,
          first_name,
          last_name,
          department,
          position,
          email
        )
      `)?.eq('permit_status', 'active')?.lte('expiry_date', thresholdDate?.toISOString()?.split('T')?.[0])?.gte('expiry_date', today?.toISOString()?.split('T')?.[0])?.order('expiry_date', { ascending: true });
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      employeeId: row?.employee_id,
      employee: row?.employees ? {
        employeeNumber: row?.employees?.employee_number,
        firstName: row?.employees?.first_name,
        lastName: row?.employees?.last_name,
        department: row?.employees?.department,
        position: row?.employees?.position,
        email: row?.employees?.email
      } : null,
      permitNumber: row?.permit_number,
      issueDate: row?.issue_date,
      expiryDate: row?.expiry_date,
      permitStatus: row?.permit_status
    })) || [];
  },

  async getExpiredPermits() {
    const today = new Date()?.toISOString()?.split('T')?.[0];

    const { data, error } = await supabase?.from('work_permits')?.select(`
        *,
        employees (
          employee_number,
          first_name,
          last_name,
          department,
          email
        )
      `)?.lt('expiry_date', today)?.eq('permit_status', 'active')?.order('expiry_date', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      employeeId: row?.employee_id,
      employee: row?.employees ? {
        employeeNumber: row?.employees?.employee_number,
        firstName: row?.employees?.first_name,
        lastName: row?.employees?.last_name,
        department: row?.employees?.department,
        email: row?.employees?.email
      } : null,
      permitNumber: row?.permit_number,
      expiryDate: row?.expiry_date
    })) || [];
  }
};

export default permitService;